import { useState } from "react"
import { uploadFile } from "./fileUpload.service"
import { optimizeImageToWebP } from "../../utils/imageOptimize"

export const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const isError = Boolean(error)

  const upload = async (file) => {
    if (!file) {
      const err = new Error("No file provided")
      setError(err)
      throw err
    }

    try {
      setIsLoading(true)
      setError(null)

      const optimizedFile = await optimizeImageToWebP(file, {
        quality: 0.75,
        maxWidth: 1600,
        maxHeight: 1600,
      })

      const result = await uploadFile(optimizedFile)
      return result
    } catch (err) {
      console.error("Upload failed:", err)
      setError(err)
      throw err
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, isError, error, upload }
}
